export const normalizePharmacistLicenseNumber = (licenseNumber: string) =>
  licenseNumber.replace(/[\s-]/g, '').trim();
